let lastPickedSnapshotElement = null;
let selectorPickMode = "article_link";

function feedAddProgressMessage(action) {
  const normalized = String(action || "").trim().toLowerCase();
  if (normalized === "preview") {
    return "Loading preview. This may take a few seconds...";
  }
  if (normalized === "manual-scrape") {
    return "Scraping site articles. This can take a little longer...";
  }
  if (normalized === "add") {
    return "Adding feed and starting initial sync...";
  }
  if (normalized === "save-selectors") {
    return "Saving selector rules...";
  }
  return "Working...";
}

export function initFeedAddSubmitProgress() {
  const forms = document.querySelectorAll("form[data-feed-add-form='1']");
  forms.forEach(function (form) {
    if (!(form instanceof HTMLFormElement)) {
      return;
    }
    if (form.dataset.submitProgressBound === "1") {
      return;
    }
    form.dataset.submitProgressBound = "1";

    form.addEventListener("submit", function (event) {
      if (form.dataset.isSubmitting === "1") {
        event.preventDefault();
        return;
      }
      form.dataset.isSubmitting = "1";

      const submitter = event.submitter instanceof HTMLElement ? event.submitter : null;
      const action = submitter ? String(submitter.getAttribute("value") || "") : "";

      if (submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement) {
        const submitterName = String(submitter.getAttribute("name") || "").trim();
        if (submitterName) {
          const existing = form.querySelector("input[type='hidden'][data-submitter-shadow='1']");
          if (existing && existing.parentElement) {
            existing.parentElement.removeChild(existing);
          }
          const hidden = document.createElement("input");
          hidden.type = "hidden";
          hidden.name = submitterName;
          hidden.value = String(submitter.getAttribute("value") || "");
          hidden.setAttribute("data-submitter-shadow", "1");
          form.appendChild(hidden);
        }
      }

      const status = form.querySelector("[data-feed-add-progress]");
      if (status instanceof HTMLElement) {
        status.textContent = feedAddProgressMessage(action);
        status.classList.remove("hidden");
      }

      form.setAttribute("aria-busy", "true");
      form.querySelectorAll("button[type='submit'], input[type='submit']").forEach(function (buttonEl) {
        if (buttonEl instanceof HTMLButtonElement || buttonEl instanceof HTMLInputElement) {
          buttonEl.disabled = true;
        }
      });
    });
  });
}

function syncFeedPreviewTitleValue() {
  const previewTitleEl = document.getElementById("feed-preview-title-value");
  if (!(previewTitleEl instanceof HTMLElement)) {
    return;
  }
  const titleInput = document.getElementById("title");
  if (!(titleInput instanceof HTMLInputElement)) {
    return;
  }

  const inputValue = String(titleInput.value || "").trim();
  const defaultTitle = String(previewTitleEl.getAttribute("data-default-title") || "").trim();
  const nextTitle = inputValue || defaultTitle;
  if (nextTitle) {
    previewTitleEl.textContent = nextTitle;
  }
}

export function initFeedPreviewTitleMirror() {
  const titleInput = document.getElementById("title");
  if (!(titleInput instanceof HTMLInputElement)) {
    return;
  }

  if (titleInput.dataset.previewMirrorBound !== "1") {
    titleInput.dataset.previewMirrorBound = "1";
    titleInput.addEventListener("input", syncFeedPreviewTitleValue);
    titleInput.addEventListener("change", syncFeedPreviewTitleValue);
  }

  syncFeedPreviewTitleValue();
}

function syncFeedAddSelectorShadowFields() {
  const addForm = document.querySelector("form[data-feed-add-form='1']");
  if (!(addForm instanceof HTMLFormElement)) {
    return;
  }

  const selectorForm = document.getElementById("selector-live-form");
  if (!(selectorForm instanceof HTMLFormElement)) {
    return;
  }

  const setShadow = function (name, value) {
    const hidden = addForm.querySelector("input[type='hidden'][data-feed-add-selector-shadow='" + name + "']");
    if (!(hidden instanceof HTMLInputElement)) {
      return;
    }
    hidden.value = String(value || "");
  };

  const enabled = selectorForm.querySelector("input[name='selector_enabled']");
  if (enabled instanceof HTMLInputElement) {
    setShadow("selector_enabled", String(enabled.value || "1"));
  }

  const enriched = selectorForm.querySelector("input[name='selector_enriched_feed']");
  if (enriched instanceof HTMLInputElement) {
    setShadow("selector_enriched_feed", enriched.checked ? "1" : "0");
  }

  [
    "selector_article_link",
    "selector_article_title",
    "selector_article_body",
    "selector_article_author",
    "selector_article_image",
    "selector_article_published",
    "selector_remove"
  ].forEach(function (name) {
    const field = selectorForm.querySelector("[name='" + name + "']");
    if (field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement) {
      setShadow(name, field.value || "");
    }
  });
}

export function initFeedAddSelectorShadowSync() {
  const selectorForm = document.getElementById("selector-live-form");
  if (!(selectorForm instanceof HTMLFormElement)) {
    return;
  }

  if (selectorForm.dataset.shadowSyncBound !== "1") {
    selectorForm.dataset.shadowSyncBound = "1";
    selectorForm.addEventListener("input", syncFeedAddSelectorShadowFields);
    selectorForm.addEventListener("change", syncFeedAddSelectorShadowFields);
  }

  syncFeedAddSelectorShadowFields();
}

function cssIdentifierEscape(value) {
  const raw = String(value || "").trim();
  if (!raw) {
    return "";
  }
  if (window.CSS && typeof window.CSS.escape === "function") {
    return window.CSS.escape(raw);
  }
  return raw.replace(/[^a-zA-Z0-9_-]/g, "\\$&");
}

function buildSelectorSegment(element, root) {
  if (!(element instanceof Element)) {
    return "";
  }
  const tag = String(element.tagName || "").toLowerCase();
  if (!tag) {
    return "";
  }

  const id = String(element.getAttribute("id") || "").trim();
  if (id) {
    const escapedID = cssIdentifierEscape(id);
    const idSelector = "#" + escapedID;
    if (root && root.querySelectorAll(idSelector).length === 1) {
      return idSelector;
    }
  }

  const classes = Array.from(element.classList || [])
    .map(function (cls) { return String(cls || "").trim(); })
    .filter(function (cls) {
      if (!cls) {
        return false;
      }
      if (cls.length > 48) {
        return false;
      }
      if (cls.indexOf("htmx") === 0 || cls.indexOf("hx-") === 0 || cls.indexOf("x-") === 0) {
        return false;
      }
      return true;
    })
    .slice(0, 2)
    .map(function (cls) { return "." + cssIdentifierEscape(cls); })
    .join("");

  let segment = tag + classes;
  const parent = element.parentElement;
  if (parent instanceof Element) {
    const sameTagSiblings = Array.from(parent.children).filter(function (child) {
      return child.tagName === element.tagName;
    });
    if (sameTagSiblings.length > 1) {
      const nth = sameTagSiblings.indexOf(element) + 1;
      if (nth > 0) {
        segment += ":nth-of-type(" + String(nth) + ")";
      }
    }
  }
  return segment;
}

function buildSelectorForSnapshotElement(element, root) {
  if (!(element instanceof Element) || !(root instanceof Element)) {
    return "";
  }

  const parts = [];
  let current = element;
  let depth = 0;
  while (current && current !== root && depth < 8) {
    const segment = buildSelectorSegment(current, root);
    if (!segment) {
      break;
    }
    parts.unshift(segment);

    const candidate = parts.join(" > ");
    try {
      if (root.querySelectorAll(candidate).length === 1) {
        return candidate;
      }
    } catch (_err) {
      // Continue with parent segments when selector is invalid.
    }

    current = current.parentElement;
    depth += 1;
  }

  return parts.join(" > ");
}

function applyPickedSelectorToForm(selector, pickedElement) {
  const mode = String(selectorPickMode || "article_link").trim().toLowerCase() || "article_link";

  const selectorsByMode = {
    article_link: "selector_article_link",
    article_title: "selector_article_title",
    article_body: "selector_article_body",
    article_author: "selector_article_author",
    article_image: "selector_article_image",
    article_published: "selector_article_published"
  };

  if (mode === "remove") {
    const removeEl = document.getElementById("selector_remove");
    if (!(removeEl instanceof HTMLTextAreaElement)) {
      return mode;
    }
    const currentValue = String(removeEl.value || "").trim();
    const parts = currentValue
      ? currentValue.split(",").map(function (item) { return String(item || "").trim(); }).filter(Boolean)
      : [];
    if (parts.indexOf(selector) === -1) {
      parts.push(selector);
    }
    removeEl.value = parts.join(", ");
    removeEl.dispatchEvent(new Event("input", { bubbles: true }));
    removeEl.dispatchEvent(new Event("change", { bubbles: true }));
    return mode;
  }

  const inputID = selectorsByMode[mode] || "selector_article_link";
  const inputEl = document.getElementById(inputID);
  if (inputEl instanceof HTMLInputElement || inputEl instanceof HTMLTextAreaElement) {
    inputEl.value = selector;
    inputEl.dispatchEvent(new Event("input", { bubbles: true }));
    inputEl.dispatchEvent(new Event("change", { bubbles: true }));
  }

  if (pickedElement instanceof HTMLElement) {
    pickedElement.scrollIntoView({ block: "nearest", inline: "nearest" });
  }
  return mode;
}

export function initSelectorSnapshotPicker() {
  if (document.body.dataset.selectorSnapshotPickerBound === "1") {
    return;
  }
  document.body.dataset.selectorSnapshotPickerBound = "1";

  document.addEventListener("click", function (event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!(target instanceof Element)) {
      return;
    }
    const snapshotRoot = target.closest("[data-selector-snapshot='1']");
    if (!(snapshotRoot instanceof HTMLElement)) {
      return;
    }
    const snapshotBody = target.closest("[data-selector-snapshot-body='1']");
    if (!(snapshotBody instanceof HTMLElement)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const pickedElement = target;
    const selector = buildSelectorForSnapshotElement(pickedElement, snapshotBody);
    if (!selector) {
      return;
    }

    if (lastPickedSnapshotElement instanceof HTMLElement) {
      lastPickedSnapshotElement.style.outline = "";
      lastPickedSnapshotElement.style.backgroundColor = "";
    }
    if (pickedElement instanceof HTMLElement) {
      pickedElement.style.outline = "2px solid #0000a5";
      pickedElement.style.backgroundColor = "rgba(0, 0, 165, 0.10)";
      lastPickedSnapshotElement = pickedElement;
    }

    const mode = applyPickedSelectorToForm(selector, pickedElement);
    const feedback = document.getElementById("selector-snapshot-feedback");
    if (feedback instanceof HTMLElement) {
      feedback.textContent = "Picked " + selector + " -> " + mode + ".";
    }
  });
}

export function setSelectorSnapshotLoadingMessage(text) {
  const feedback = document.getElementById("selector-snapshot-feedback");
  if (!(feedback instanceof HTMLElement)) {
    return;
  }
  feedback.textContent = String(text || "");
}

function setSelectorPickMode(mode) {
  const normalized = String(mode || "").trim().toLowerCase() || "article_link";
  selectorPickMode = normalized;

  const liveHiddenEl = document.getElementById("selector_pick_target_hidden");
  if (liveHiddenEl instanceof HTMLInputElement) {
    liveHiddenEl.value = normalized;
  }

  const snapshotHiddenEl = document.getElementById("selector_snapshot_pick_target_hidden");
  if (snapshotHiddenEl instanceof HTMLInputElement) {
    snapshotHiddenEl.value = normalized;
  }

  const labelEl = document.getElementById("selector-snapshot-picked-mode");
  if (labelEl instanceof HTMLElement) {
    labelEl.textContent = normalized;
  }
}

export function syncSelectorSnapshotPickerTargetText() {
  const liveHiddenEl = document.getElementById("selector_pick_target_hidden");
  if (liveHiddenEl instanceof HTMLInputElement) {
    setSelectorPickMode(liveHiddenEl.value);
    return;
  }
  setSelectorPickMode(selectorPickMode);
}

export function initSelectorPickerTargetFocusSync() {
  if (document.body.dataset.selectorPickerFocusSyncBound === "1") {
    return;
  }
  document.body.dataset.selectorPickerFocusSyncBound = "1";

  const targetByInputID = {
    selector_article_link: "article_link",
    selector_article_title: "article_title",
    selector_article_body: "article_body",
    selector_article_author: "article_author",
    selector_article_image: "article_image",
    selector_article_published: "article_published",
    selector_remove: "remove"
  };

  document.addEventListener("focusin", function (event) {
    const target = event.target instanceof HTMLElement ? event.target : null;
    if (!target) {
      return;
    }
    const nextMode = targetByInputID[target.id || ""];
    if (!nextMode) {
      return;
    }
    if (String(selectorPickMode || "") === nextMode) {
      return;
    }
    setSelectorPickMode(nextMode);
  });
}
